import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120">
    <title>Loader Logo</title>
    <g>
      <text
        x="50%"
        y="60%"
        textAnchor="middle"
        fill="currentColor"
        fontSize="40"
        fontFamily="Arial, sans-serif"
        fontWeight="bold">
        Ann
      </text>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 60, 10
                  L 15, 35
                  L 15, 85
                  L 60, 110
                  L 105, 85
                  L 105, 35 z"
      />
    </g>
  </svg>
);

export default IconLoader;
